import React, { memo, useCallback } from 'react';
import classnames from 'classnames';
import Icon from '../Icon';
import { IconBackgroundColors, IconColors, IconSizes, IconVariants } from '../../constants';
import './ButtonIcon.scss';
const ButtonIcon = ({ size = IconSizes.Medium, variant = IconVariants.Plain, color = IconColors.Primary, backgroundColor = IconBackgroundColors.Primary, hasPropagation = true, disabled = false, clickHandle = (e) => null, children = null, }) => {
    const rootClassNames = classnames({
        'ml-button-icon': true,
        'ml-button-icon--disabled': disabled,
    });
    const internalClickHandle = useCallback((e) => {
        if (!hasPropagation) {
            e.stopPropagation();
        }
        return clickHandle(e);
    }, [hasPropagation, clickHandle]);
    return (<button className={rootClassNames} onClick={internalClickHandle} disabled={disabled} type="button">
      <Icon color={color} variant={variant} size={size} backgroundColor={backgroundColor}>
        {children}
      </Icon>
    </button>);
};
export default memo(ButtonIcon);
